module.exports = __webpack_public_path__ + "static/media/Metropolis Regular-01.95b70012.svg";